import { render } from "./ViewClasses.vue?vue&type=template&id=9bedde56&scoped=true"
import script from "./ViewClasses.vue?vue&type=script&lang=js"
export * from "./ViewClasses.vue?vue&type=script&lang=js"

import "./ViewClasses.vue?vue&type=style&index=0&id=9bedde56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bedde56"]])

export default __exports__